export function openRouteInNewTab(router, routeName, params) {
    const routeData = router.resolve({
        name: routeName,
        params: params
    });
    window.open(routeData.href, '_blank');
}